import React from 'react';
import { SectionHeading } from '../ui/SectionHeading';
import { Check } from 'lucide-react';
import { motion } from 'framer-motion';
export function WhatIsDigitalKey() {
  const highlights = ['Smartphone übernimmt Funktionen des klassischen Schlüssels', 'Hardware-Modul fahrzeugspezifisch installiert (OEM-konform)', 'Bedienung per BLE (Bluetooth) oder 4G Remote', 'Smart Access: Annähern = entriegeln, Entfernen = verriegeln', 'Schlüssel sicher teilen (Familie / Freunde / Mitarbeiter)'];
  return <section className="py-24 bg-[#0a0a0f]" data-id="element-234">
      <div className="container mx-auto px-4 md:px-6" data-id="element-235">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-236">
          <div data-id="element-237">
            <SectionHeading title="Was ist ein digitaler Autoschlüssel?" subtitle="Ein Digital Key ersetzt den klassischen Autoschlüssel durch eine sichere Smartphone-Funktion. Mit einem im Fahrzeug installierten Hardware-Modul und einer App steuern Nutzer wichtige Fahrzeugfunktionen bequem per Bluetooth oder mobil über 4G." data-id="element-238" />

            <ul className="space-y-4 mt-8" data-id="element-239">
              {highlights.map((item, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex items-start gap-3" data-id="element-240">
                  <div className="mt-1 w-5 h-5 rounded-full bg-cyan-500/20 flex items-center justify-center flex-shrink-0" data-id="element-241">
                    <Check className="w-3 h-3 text-cyan-400" data-id="element-242" />
                  </div>
                  <span className="text-gray-300" data-id="element-243">{item}</span>
                </motion.li>)}
            </ul>
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="relative" data-id="element-244">
            <div className="aspect-square rounded-[32px] overflow-hidden border border-gray-800 shadow-2xl relative z-10" data-id="element-245">
              <video src="https://cdn.magicpatterns.com/uploads/2fNBy17fwL8B4y5PJmxQcF/tika_showreel.undefined" autoPlay loop muted playsInline className="w-full h-full object-cover scale-125" data-id="element-246" />
            </div>

            {/* Decorative elements */}
            <div className="absolute -top-10 -right-10 w-64 h-64 bg-cyan-500/20 rounded-full blur-3xl -z-10" data-id="element-247" />
            <div className="absolute -bottom-10 -left-10 w-64 h-64 bg-blue-600/20 rounded-full blur-3xl -z-10" data-id="element-248" />
          </motion.div>
        </div>
      </div>
    </section>;
}